import HomeIcon from "@mui/icons-material/Home";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import GroupsIcon from "@mui/icons-material/Groups";
import InterpreterModeOutlinedIcon from "@mui/icons-material/InterpreterModeOutlined";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import routes from "../../../Utils/routes";
import { useStyles } from "../styles";
import { ListItemButton, ListItemText } from "@mui/material";
import { useLocation } from "react-router-dom";

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split("/").filter((items: string) => {
    return items && items !== "";
  });

  const sideNavContents = [
    {
      icon: (isActive: boolean) => {
        return <HomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: "Home",
      link: routes.home,
      name: "home",
    },
    {
      icon: (isActive: boolean) => {
        return <AutoAwesomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: "Events",
      link: routes.events,
      name: "events",
    },
    {
      icon: (isActive: boolean) => {
        return <HowToRegIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: "Jobs",
      link: routes.jobs,
      name: "jobs",
    },
    {
      icon: (isActive: boolean) => {
        return <InterpreterModeOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: "Mentorship",
      link: routes.mentorship,
      name: "mentorship",
    },
    {
      icon: (isActive: boolean) => {
        return <InterpreterModeOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: "Fundraiser",
      link: routes.mentorship,
      name: "fundraiser",
    },
    {
      icon: (isActive: boolean) => {
        return <InterpreterModeOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: "Network",
      link: routes.mentorship,
      name: "network",
    },
    {
      icon: (isActive: boolean) => {
        return <GroupsIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: "Groups",
      link: routes.groups,
      name: "groups",
    },
    {
      icon: (isActive: boolean) => {
        return <SchoolRoundedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: "Survey",
      link: routes.alumni,
      name: "survey",
    },
    {
      icon: (isActive: boolean) => {
        return <ContactSupportIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: "Service & Support",
      link: routes.service,
      name: "service",
    },
  ];

  return sideNavContents?.map((items, index) => {
    return (
      <ListItemButton
        onClick={() => {
          handleListClick(items.link, index);
        }}
        style={{ marginTop: index === 0 ? "15px" : "auto" }}
        className={`${classes.listItemButton} ${getFirstPath[0] === items.name && classes.listItemButtonActive}`}
      >
        <div style={{ margin: "0px 16px 0px 0px", padding: "2px 0px" }}>{items.icon(getFirstPath[0] === items.name)}</div>
        <ListItemText className={`${classes.listItemText} ${getFirstPath[0] === items.name && classes.listItemTextActive}`}>{items.label}</ListItemText>
      </ListItemButton>
    );
  });
};

export default SideNavTabs;
